module.exports = __webpack_public_path__ + "static/img/4.e52c8cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/4.png
// module id = MkIb
// module chunks = 0